import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormControl, FormGroup} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {ApprovalService} from '../../../service/approval.service';
import {PaymentModel} from '../../../model/payment.model';
import {ApprovalPending} from '../../../shared/dto/approval-pending';
import Swal from "sweetalert2";
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {ApplicantRequestSearchModel} from '../../../model/applicantRequestSearchModel';
import {NationalityService} from '../../../shared/service/nationality.service';
import {NationalityModel} from '../../../shared/dto/nationality.model';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {CityPopupComponent} from '../../../full-pages-admin-panel/location-mgt/city/city-popup/city-popup.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BlacklistApproveChecklistComponent} from '../../../blacklist-process/blacklist-approve-checklist/blacklist-approve-checklist.component';
import {CardPreviewPopupComponent} from '../card-preview-popup/card-preview-popup.component';
import {DocumentViwerPopupComponent} from '../document-viwer-popup/document-viwer-popup.component';
import {DocumentTypeModel} from '../../../shared/dto/document-type.model';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import {DocumentDetailsService} from '../../../service/document-details.service';
import {DocumentViewerPopupComponent} from '../document-viewer-popup/document-viewer-popup.component';
import {DocumentPage} from '../../../shared/dto/document-page';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-applicant-data',
  templateUrl: './applicant-data.component.html',
  styleUrls: ['./applicant-data.component.scss']
})
export class ApplicantDataComponent implements OnInit {
  @Input() applicationId: number;
  applicantSearchForm: FormGroup;
  public approvalPending: ApprovalPending;
  public nationality: NationalityModel[];
  female: boolean;
  male: boolean;
  isError: boolean = false;
  isSucess: boolean = false;
  isErrorContact: boolean = false;
  isSucessContact: boolean = false;
  personalDto: ApprovalPending = new ApprovalPending();
  contactDto: ApprovalPending = new ApprovalPending();
  applicantRequestSearchDetails: ApplicantRequestSearchModel;
  userName: string;
  userRole: string;
  retrievedImage: string;
  base64Data: string;
  signature: string;
  imgrighthand: string;
  imglefthand: string;
  thumbright: string;
  thumbleft: string;
  isLoading1: boolean = false;
  isLoading2: boolean = false;
  isLoading3: boolean = false;
  isLoading4: boolean = false;
  isLoading5: boolean = false;
  showAddresserror=false;
  showspecialCharacerror=false;
  showbirthPlaceerror=false;

  public showLable1 :boolean = false;
  public  showLable2:boolean =  false;
  public showdiv: boolean = false;
  public showdiv2: boolean = false;
  public showdiv3: boolean = false;

  public documentTypeModel: DocumentTypeModel[];
  public documentType= new DocumentTypeModel();
  displayedColumns: string[] = ['description','action'];
  dataSource: MatTableDataSource<any>;
  public page: any = [];
  public loader: boolean = false;
  public safeUrl: SafeResourceUrl;
  isLoading: boolean = false;
  public application: number;
  isLoading10: boolean = false;

  public pages:DocumentPage;
  documentDetails: any = [];
  blob: any;
  pipe = new DatePipe('en-US');
  docType: DocumentTypeModel = new DocumentTypeModel();
  constructor(private approvalService: ApprovalService, private tokenStorageService: TokenStorageService,
              private nationalityService: NationalityService,
              public modalService: NgbModal,
              private applicantRequestService: ApplicantRequestService, private documentDetailsService: DocumentDetailsService,
              private sanitizer: DomSanitizer ) {
  }

  ngOnInit() {
    this.getDocumentType();
    this.applicantSearchForm = new FormGroup({
      remark: new FormControl(null),
      appRefNo: new FormControl(null),
      appType: new FormControl(null),
      status: new FormControl(null),
      createDate: new FormControl(null),
      cdcNo: new FormControl(null),
      cocNo: new FormControl(null),
      cdcExpDate: new FormControl(null),
      cocDate: new FormControl(null),
      fullName: new FormControl(null),
      familyName: new FormControl(null),
      givenName: new FormControl(null),
      initialName: new FormControl(null),
      nic: new FormControl(null),
      nicIssueDate: new FormControl(null),
      dob: new FormControl(null),
      gender: new FormControl(null),
      birthPlace: new FormControl(null),
      nationality: new FormControl(null),
      specialCharac: new FormControl(null),
      bioRefNo: new FormControl(null),
      photoDate: new FormControl(null),
      photoExpDate: new FormControl(null),
      address: new FormControl(null),
      mobile: new FormControl(null),
      email: new FormControl(null),
    });
    this.getNationality();
    this.onSearch();
    this.getApplicantDetails();
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }

  private getNationality(): void {
    this.nationalityService.getAllNationalities().subscribe(
      (data: NationalityModel[]) => {
        this.nationality = data;
      }
    );
  }

  onSearch() {
    this.isLoading1 = true;
    this.isLoading2 = true;
    this.isLoading3 = true;
    this.isLoading5 = true;
    this.approvalService.searchApplicantData(this.applicationId).subscribe(
      (data: any ) => {
      this.approvalPending = data;

        if(this.approvalPending.cdcAvailable === "1") {
          this.showLable1 = true;
        }
        if(this.approvalPending.cdcAvailable === "0") {
          this.showLable2 = true;
        }

        this.isLoading1 = false;
        this.isLoading2 = false;
        this.isLoading3 = false;
        this.isLoading5 = false;
        this.applicantSearchForm.patchValue(
          {
            remark: this.approvalPending.remark,
            status: this.approvalPending.stage,
            appType: this.approvalPending.type,
            nic: this.approvalPending.nic,
            createDate: this.approvalPending.createdDate,
            fullName: this.approvalPending.name,
            appRefNo: this.approvalPending.appRefNo,
            cdcNo: this.approvalPending.cdcNo,
            cocNo: this.approvalPending.cocNo,
            cdcExpDate: this.approvalPending.cdcExpDate,
            cocDate: this.approvalPending.cocDate,
            familyName: this.approvalPending.familyName,
            givenName: this.approvalPending.givenName,
            initialName: this.approvalPending.initialName,
            nicIssueDate: this.approvalPending.nicIssueDate.toString().substring(0, 10),
            dob: this.approvalPending.dob.toString().substring(0, 10),
            gender: this.approvalPending.gender,
            birthPlace: this.approvalPending.birthPlace,
            nationality: this.approvalPending.nationality,
            specialCharac: this.approvalPending.specialCharac,
            bioRefNo: this.approvalPending.bioRefNo,
            photoDate: this.approvalPending.photoDate,
            photoExpDate: this.approvalPending.photoExpDate,
            address: this.approvalPending.address,
            mobile: this.approvalPending.mobile,
            email: this.approvalPending.email,
          }

        );

        if (this.approvalPending.gender === 'Male') {
          this.male = true;
          this.female = false;
        }
        if (this.approvalPending.gender === 'Female') {
          this.male = false;
          this.female = true;
        }
      }
    );
  }

  getApplicantDetails(){
    this.isLoading4 = true;
    this.approvalService.getApplicantDetails(this.applicationId).subscribe(
      (data: ApplicantRequestSearchModel) =>{
        this.isLoading4 = false;
        this.applicantRequestSearchDetails = data;
        this.applicantSearchForm.patchValue(
          {
            bioRefNo: this.applicantRequestSearchDetails.reference,
            photoDate: this.applicantRequestSearchDetails.photodate,
            photoExpDate: this.applicantRequestSearchDetails.expiryDate,
          }
        );
        this.retrievedImage = this.applicantRequestSearchDetails.image;
        this.signature = this.applicantRequestSearchDetails.imgsignature;
        this.imgrighthand = this.applicantRequestSearchDetails.imgrighthand;
        this.imglefthand = this.applicantRequestSearchDetails.imglefthand;
        this.thumbright = this.applicantRequestSearchDetails.thumbright;
        //this.thumbleft = this.applicantRequestSearchDetails.thumbleft;

        this.base64Data = window.atob(this.retrievedImage);
      }
    )
  }

  savePersonalData() {

    var isValid = false;
    var format = /[!@#$%^&*()_+\=\[\]{};':"\\|<>\?]+/;

    if(format.test(this.applicantSearchForm.value.specialCharac) && format.test(this.applicantSearchForm.value.birthPlace)){
      isValid = false;
      this.showspecialCharacerror=true;
      this.showbirthPlaceerror=true;
    }else if(format.test(this.applicantSearchForm.value.specialCharac) || format.test(this.applicantSearchForm.value.birthPlace)){

      if(format.test(this.applicantSearchForm.value.specialCharac)){
        this.showspecialCharacerror=true;
        isValid = false;
      } else if(format.test(this.applicantSearchForm.value.birthPlace)){
        isValid = false;
        this.showbirthPlaceerror=true;
      }

    }else{
      isValid = true;
      this.showspecialCharacerror=false;
      this.showbirthPlaceerror=false;
    }

    if(isValid){
      this.personalDto.name = this.applicantSearchForm.value.fullName;
      this.personalDto.familyName = this.applicantSearchForm.value.familyName;
      this.personalDto.givenName = this.applicantSearchForm.value.givenName;
      this.personalDto.initialName = this.applicantSearchForm.value.initialName;
      this.personalDto.nic = this.applicantSearchForm.value.nic;
      this.personalDto.nicIssueDate = this.applicantSearchForm.value.nicIssueDate;
      this.personalDto.dob = this.applicantSearchForm.value.dob;
      this.personalDto.gender = this.applicantSearchForm.value.gender;
      this.personalDto.birthPlace = this.applicantSearchForm.value.birthPlace;
      this.personalDto.specialCharac = this.applicantSearchForm.value.specialCharac;
      this.personalDto.appRefNo = this.approvalPending.appRefNo;
      this.personalDto.loginUser = this.userName;

      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to update the applicant details?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.approvalService.proceedPersonalData(this.personalDto).subscribe(
            (success: string) => {
              this.isSucess = true;
            },
            (error) => {
              this.isError = true;
            },
          );
        } else {
        }
      });
    }

  }

  saveContactData() {
    var isValid = false;
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|<>\?]+/;

    if(format.test(this.applicantSearchForm.value.address) || /\r|\n/.exec(this.applicantSearchForm.value.address)){
      isValid = false;
      this.showAddresserror=true;
    }else{
      isValid = true;
      this.showAddresserror=false;
    }

    if(isValid){
      this.contactDto.appRefNo = this.approvalPending.appRefNo;
      this.contactDto.loginUser = this.userName;
      this.contactDto.email = this.applicantSearchForm.value.email;
      this.contactDto.address = this.applicantSearchForm.value.address;
      this.contactDto.mobile = this.applicantSearchForm.value.mobile;

      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to update the contact details?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.approvalService.proceedContactData(this.contactDto).subscribe(
            (success: string) => {
              this.isSucessContact = true;
            },
            (error) => {
              this.isErrorContact = true;
            },
          );
        } else {
        }
      });
    }
  }

  openModelPreview() {
    this.showdiv = true;
  }

  view() {
    this.isLoading = true;
    this.applicantRequestService.cardPreview(this.applicationId).subscribe(
      (data: any) => {
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank",  "width=800,height=400");
        this.isLoading = false;
      },
      error => {
        this.isLoading = false;
        console.log(error);
      }
    );
  }

  getDocumentType() {
    this.isLoading = true;
    this.applicantRequestService.getDocumentType(this.applicationId).subscribe(
      (result: any ) => {
        this.isLoading = false;
        this.documentTypeModel = result;
        this.dataSource = new MatTableDataSource(this.documentTypeModel);
      }
    );
  }

  getPages(documentTypeCode) {
    this.loader = true;
    this.docType.appRefID = this.applicationId;
    this.docType.documentTypeCode = documentTypeCode;
    this.documentDetailsService.getPages(this.docType).subscribe(
      (data) => {
        if (data !== null && data !== "") {
          this.page = data;
          this.page.content.forEach(element => {
            this.documentDetails.push(element);
          });
        }
        this.loader = false;
      },
      error => {
        this.loader = false;
        Swal.fire(`Internal Server Error`, error.message, "error");
      }
    );
  }

  transform(base64Image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }

  viewDoc(documentTypeCode:string) {
    this.isLoading10 = true;
    this.documentType.appRefID = this.applicationId;
    this.documentType.documentTypeCode = documentTypeCode;
    this.applicantRequestService.cardViewDoc(this.documentType).subscribe(
      (data: any) => {
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank",  "width=800,height=400");
        this.isLoading10 = false;
      },
      error => {
        this.isLoading10 = false;
        console.log(error);
      }
    );
   // this.showdiv2 = true;
   // this.getPages(documentTypeCode);
  }

  closeModel1 (){
    this.showdiv = false;
    this.showdiv2 = false;
  }
}
